import React, { useEffect, useRef, useState } from 'react';
import { useLocation } from "react-router";
import { Link, useParams } from 'react-router-dom';
//axios
import useAxiosHook from 'src/webapp/hooks/comn/axios.hook';
//fontAwesome
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
//styles
import styles from 'src/asset/scss/style/market.detail.module.scss';
//store
import usePartnerStore from 'src/webapp/stores/partner.store';
//comp-wrapper
import Section from 'src/webapp/views/wrapper/Section';
import FixedPanel from 'src/webapp/views/wrapper/FixedPanel';
import FlickPanel from 'src/webapp/views/wrapper/FlickPanel';
//comp
import Element from 'src/webapp/views/wrapper/Element';//공통엘리먼트
import Menu from 'src/webapp/views/component/Menu';//메뉴
import MarketDetailImgList from './MarketDetail.ImgList';//마켓-상품이미지
import MarketDetailInfo from './MarketDetail.Info';//마켓-상품내용
import MarketUpdateBottomsheet from './bottomsheet/MarketUpdate';//상품 - 삭제 및 수정
import MarketSuccessBottomsheet from './bottomsheet/MarketSuccess';//상품 - 거래완료

export default function MarketDetail() {
    const param = useParams();
    const { state } = useLocation();//location
    const { axiosPostHandler } = useAxiosHook();//axios
    const { partner } = usePartnerStore();

    /* =============== 상품상세내역 =============== */
    const [ detail,setDetail ] = useState({});
    const marketItemLAPI = async() => {
        const DATA = { SEQ_NO:param.seq, RANGE:1};
        const result = await axiosPostHandler(`marketItemDetailForJson.do`, DATA);
        if(!result || result.message !== "SUCCESS") { return; }
        if(result.message === "SUCCESS") {
            setDetail(result.data);
        }
    }
    useEffect(() => {
        marketItemLAPI();
    }, []);
    /* =============== 상품상세내역 =============== */
    /* =============== 문의하기 버튼활성화여부 =============== */
    const isDisabledHandler = () => {
        if(partner.COMN_CD === detail.PARTNER_CD || detail.STATUS === '3' ? true : false) {
            return true;
        }
        return false;
    }
    /* =============== 문의하기 버튼활성화여부 =============== */
    /* =============== 문의하기 API =============== */
    const isLock = useRef(false);
    const marketItemContractAPI = async() => {
        if(isLock.current) { return; }

        isLock.current = true;
        const DATA = { SEQ_NO:param.seq, TYPE:1, USER_CD:partner.COMN_CD};
        const result = await axiosPostHandler(`marketItemContractForJson.do`, DATA);
        setTimeout(() => { isLock.current = false; }, 300);
        if(!result || result.message !== "SUCCESS") { return; }
        if(result.message === "SUCCESS") {}
    }
    /* =============== 문의하기 API =============== */
    /* =============== 현재상태필터 =============== */
    const statusFilter = () => {
        switch(detail?.STATUS) {
            case '2' : return '예약중';
            case '3' : return '거래완료';
            default : return '문의하기';
        }
    }
    /* =============== 현재상태필터 =============== */
    const [ isOpen,setOpen ] = useState({update:false, success: false});
    const onDismissHandler = (state, value) => {
        let obj = {};
        Object.keys(isOpen).map(item => {
            if (item == state) { obj[item] = value; }
            else { obj[item] = false; }
        });
        if (state.length > 0) { return setOpen(obj); }
    }
    return (
        <>
        <Section className={["section sectionContainer", styles.marketSection].join(' ')}>
            <Menu />
            <Element tag={`div`} className={`container`}>
                <FixedPanel>
                    <Element tag={`div`} className={styles.titleBar}>
                        <Element tag={`div`}>
                            <Link to={-1}><FontAwesomeIcon icon="fa-light fa-arrow-left" /></Link>
                            <Element tag={`h1`}></Element>
                            {detail?.PARTNER_CD === partner.COMN_CD?
                                <Element tag={`button`} anyprop={(e) => onDismissHandler("update", true)}><FontAwesomeIcon icon="fa-light fa-ellipsis" /></Element>
                            : <Element tag={`button`}></Element>}
                        </Element>
                    </Element>
                </FixedPanel>
                <FlickPanel>
                    <div className={styles.marketDetailContainer}>
                        <div className={styles.imgArea}>
                            {detail?.IMG_LIST?.length > 0 ?
                                <MarketDetailImgList list={detail.IMG_LIST} />
                            : null }
                        </div>
                        <hr/>
                        <MarketDetailInfo data={detail} disabled={isDisabledHandler} onContract={marketItemContractAPI} onStatusFilter={statusFilter} onDismiss={onDismissHandler} />
                    </div>
                </FlickPanel>
                <FixedPanel className={styles.FixedPanel}>
                    <div className={styles.btnArea} onClick={(e) => marketItemContractAPI()}>
                        <button disabled={isDisabledHandler()}><a href={!isDisabledHandler() ? `tel:+82${detail.TEL_NO}` : null} ><span>{statusFilter()}</span></a></button>
                    </div>
                </FixedPanel>
            </Element>
        </Section>
        {isOpen.update ? <MarketUpdateBottomsheet data={detail} isOpen={isOpen.update} onDismiss={onDismissHandler} /> : null}
        {isOpen.success ? <MarketSuccessBottomsheet isOpen={isOpen.success} onDismiss={onDismissHandler} marketItemLAPI={marketItemLAPI} /> : null}
        </>
    );
}